import { QueryClient } from '@tanstack/react-query';
import { isStepUpRefusal } from './stepUp';

/**
 * XBIT-4777 D13.4: react-admin builds `new QueryClient()` when `<Admin>` gets none, and its queries retry 3 times. A
 * query the service refused with STEP_UP_REQUIRED or STEP_UP_UNAVAILABLE must not: after a Cancel on the dialog the
 * retries would reopen it. Every other error keeps the default of 3 retries; mutations keep their default of 0.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount: number, error: unknown) => !isStepUpRefusal(error) && failureCount < 3,
    },
  },
});
